exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cashbox-details__title[data-v-9c245590] {\n  margin: 12px 0;\n}\n.cashbox-details .btn-wrap[data-v-9c245590] {\n  max-width: 300px;\n}\n.reject_reason-input[data-v-9c245590] {\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n.small_danger[data-v-9c245590] {\n  padding-top: 0;\n  margin-top: 0;\n  font-size: 0.7rem;\n  font-weight: bold;\n  /*    color: $col-danger;*/\n}\n.kyc-button[data-v-9c245590] {\n  max-width: 6rem;\n  margin-left: -8px;\n  /*    background: $gray;*/\n}\n.kyc-button[data-v-9c245590]:hover {\n    /*      background: $blue !important;\n      color: $white !important;*/\n    cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9c245590","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/cashbox/index/Cashbox.Details.vue
// module id = RuPq
// module chunks = 1